var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Experiments")]), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": ""
    },
    on: {
      "click": _vm.newItem
    }
  }, [_vm._v("New")]), _c('el-button', {
    attrs: {
      "size": "mini",
      "icon": "el-icon-data-line",
      "round": ""
    },
    on: {
      "click": _vm.showResults
    }
  }, [_vm._v("Results on Mixpanel")]), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": "Refreshes the mapping between experiments and cohort users"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "icon": "el-icon-refresh",
      "round": "",
      "loading": _vm.loading.experimentCohortsRefresh
    },
    on: {
      "click": _vm.refreshExperimentsCohorts
    }
  }, [_vm._v(" Refresh Experiments/Cohorts mapping ")])], 1)], 1)]), _c('Table', {
    attrs: {
      "items": _vm.experiments,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "filterProp": "name",
      "loading": _vm.loading.experiments
    }
  }), _c('EditDialog', {
    attrs: {
      "item": _vm.item,
      "isOpen": _vm.showEditDialog,
      "onClose": function () {
        return _vm.showEditDialog = false;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }